var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 5.085c0 .439.283.695.72.695h3.667v9.099c0 .439.282.722.72.722h9.038v3.63c0 .458.292.769.73.769.447 0 .738-.31.738-.768v-3.63h3.657c.447 0 .73-.266.73-.687 0-.43-.283-.695-.73-.695h-3.657V5.13c0-.439-.282-.731-.72-.731H5.855V.769C5.855.31 5.563 0 5.116 0c-.437 0-.73.31-.73.768v3.63H.72c-.437 0-.72.266-.72.687m6.12 9.135c-.201 0-.265-.064-.265-.265V5.78h8.026c.2 0 .264.073.264.265v8.175z"
  })));
};
export default SvgCrop;